module.exports = __webpack_public_path__ + "img/shrewd-save-3.4241dabc.webp";